{
  "name": "22edo (HEJI)",
  "description": "22-tone equal tempered scale consisting of 22 sonically equal divisions per octave. The HEJI notation indicates how this temperament may be considered to present a distorted approximation of 5-limit JI.",
  "scale": [
    "1\\22",
    "2\\22",
    "3\\22",
    "4\\22",
    "5\\22",
    "6\\22",
    "7\\22",
    "8\\22",
    "9\\22",
    "10\\22",
    "11\\22",
    "12\\22",
    "13\\22",
    "14\\22",
    "15\\22",
    "16\\22",
    "17\\22",
    "18\\22",
    "19\\22",
    "20\\22",
    "21\\22",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "22edo",
  "built_in_group": "Equal Divisions",
  "key_labels": "note_names",
  "note_names": [
    "C",
    "D",
    "C D",
    "D",
    "D",
    "E",
    "E",
    "E",
    "E",
    "F",
    "F G",
    "F G",
    "F G",
    "G",
    "A",
    "A",
    "A",
    "A",
    "B",
    "B",
    "B",
    "B"
  ],
  "note_colors": [
    "#ffcbcb",
    "#d0d0d7",
    "#dee2da",
    "#fffae5",
    "#ffffff",
    "#d0d0d7",
    "#dee2da",
    "#fffae5",
    "#ffffff",
    "#ffffff",
    "#d0d0d7",
    "#dee2da",
    "#fffae5",
    "#ffffff",
    "#d0d0d7",
    "#dee2da",
    "#fffae5",
    "#ffffff",
    "#d0d0d7",
    "#dee2da",
    "#fffae5",
    "#ffffff"
  ],
  "equivSteps": 22,
  "fundamental": 440,
  "reference_degree": 17,
  "center_degree": 0,
  "rSteps": 4,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
